import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';
import { HeaderService } from 'src/app/nutrigenic/services/header/header.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  
  
  @Input() goToPage: string = 'home';

  new_password: string = '';
  new_password_confirmation: string = '';
  change_p_id: string = '';
  change_p_token: string = '';
  visible: boolean = false;

  constructor(
    private authService: AuthService,
    private headerService: HeaderService,
    private route: ActivatedRoute,
    private router: Router){}

    ngOnInit() {
        this.route.queryParams.subscribe((params: any) => {
            //console.log(params);
            if (params["token"]) {
                this.change_p_id = params["user_id"];
                this.change_p_token = params["token"];
                this.visible = true;
            }
        });
    }

  changePassword() {
        if (this.new_password.length >= 8 && this.new_password == this.new_password_confirmation) {
            this.authService.changePassword({ user_id: this.change_p_id, forgot_password_token: this.change_p_token, password: this.new_password, password_confirmation: this.new_password_confirmation }).subscribe((res: any) => {
                console.log(res);
                if (res.body.message == 'error') {
                    this.handleErrorChangePassword();
                } else {
                    this.handleResponseChangePassword();
                }

                this.closeChangePassword();
                this.router.navigate([this.goToPage]);

            });
        } else if (this.new_password.length < 8) {
            this.handleErrorPassword();
        } else if (this.new_password != this.new_password_confirmation) {
            this.handleErrorPasswordConfirmation();
        }
  }


  handleErrorPassword() {
      Notify.failure('The password must be at least 8 characters', {
          position: 'right-top',
          timeout: 3000
      });
  }


  handleErrorPasswordConfirmation() {
      Notify.failure('The password confirmation does not match', {
          position: 'right-top',
          timeout: 3000
      });
  }


  handleResponseChangePassword(): void {
      this.headerService.updateOpenDialog(true);
      Notify.success('Password successfully changed', {
          position: 'right-top',
          timeout: 3000
      });
  }
  handleErrorChangePassword() {
      Notify.failure('Token expired', {
          position: 'right-top',
          timeout: 3000
      });
  }

  closeChangePassword() {
    this.new_password = '';
    this.new_password_confirmation = '';
    this.change_p_id = '';
    this.change_p_token = '';
    this.visible = false;
  }

}
